import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TerminatePopupModel } from 'common/models/page-models/Terminate Popup Model/terminate-popup-data.model';
import { TerminatePopupMetaModel } from 'common/models/page-models/Terminate Popup Model/terminate-popup-meta.model';
import { StudentsFilterModel } from 'common/models/page-models/student/filtermodel/student-filter.data.model';
import { StudentsFilterMetaModel } from 'common/models/page-models/student/filtermodel/student-filter.meta.model';
import { StudentsModel } from 'common/models/page-models/student/formmodel/student-data.model';
import { StudentsListingModel } from 'common/models/page-models/student/gridmodel/student-grid.data.model';
import { WidgetModel } from 'common/models/utility-models/base-model';
import { GridWidgetModel } from 'common/models/utility-models/list-utility.model';
import { GridResolver } from 'common/resolvers/core-resolvers/grid.resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { StudentsGridWidgetService } from 'common/widget/students/students-grid-widget.service';

@Injectable({
    providedIn: 'root'
})
export class StudentsGridResolver extends GridResolver<StudentsModel, StudentsListingModel> {
    constructor(
        protected fs: StudentsGridWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
        
    }

    override initWidget(envelopeType: any, transferData: any): WidgetModel {
        const widget = new GridWidgetModel();
        const metaModel = this.pageService.getMetaModel();
        widget.recordPerPage = metaModel.properties?.recordPerPage;
        widget.searchableFeilds = metaModel.properties?.searchableFields;
        transferData.filterData = new StudentsFilterModel();
        transferData.filterMeta = new StudentsFilterMetaModel().getMetaModel();
        transferData.terminateData = new TerminatePopupModel();
        transferData.terminateMeta = new TerminatePopupMetaModel().getMetaModel();
        this.fs.getFilterOptions(transferData.filterMeta);
        widget.transferData = transferData;
        return widget;
    }
}
